// before 20-5-2026

// import React, { useEffect, useState } from 'react';
// import { Container } from 'react-bootstrap';
// import Avatar from '@mui/material/Avatar';
// import { styled, useTheme } from '@mui/material/styles';
// import moment from 'moment-timezone';
// import PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid';
// import AlternateEmailIcon from '@mui/icons-material/AlternateEmail';
// import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
// import PersonIcon from '@mui/icons-material/Person';
// import PushPinIcon from '@mui/icons-material/PushPin';
// import AutorenewIcon from '@mui/icons-material/Autorenew';
// import CheckCircleIcon from '@mui/icons-material/CheckCircle';
// import CircleIcon from '@mui/icons-material/Circle';
// import Card from '@mui/material/Card';
// import CardContent from '@mui/material/CardContent';
// import Typography from '@mui/material/Typography';
// import Box from '@mui/material/Box';
// import Paper from '@mui/material/Paper';
// import Chip from '@mui/material/Chip';
// import Grid from '@mui/material/Grid';

// const ProfileCard = styled(Card)(({ theme }) => ({
//   borderRadius: '16px',
//   overflow: 'visible',
//   backgroundColor: theme.palette.background.paper,
//   boxShadow: theme.shadows[3],
//   transition: 'transform 0.2s ease, box-shadow 0.2s ease',
//   '&:hover': {
//     transform: 'translateY(-2px)',
//     boxShadow: theme.shadows[6],
//   },
// }));

// const AvatarContainer = styled(Box)(({ theme }) => ({
//   position: 'relative',
//   display: 'inline-block',
// }));

// const StyledAvatar = styled(Avatar)(({ theme }) => ({
//   width: 120,
//   height: 120,
//   border: `4px solid ${theme.palette.mode === 'dark' ? theme.palette.grey[800] : '#ffffff'}`,
//   boxShadow: theme.shadows[2],
//   backgroundColor: theme.palette.primary.main,
// }));

// const InfoCard = styled(Paper)(({ theme }) => ({
//   padding: '20px',
//   borderRadius: '12px',
//   backgroundColor: theme.palette.background.paper,
//   border: `1px solid ${theme.palette.divider}`,
//   height: '100%',
// }));

// const IconContainer = styled(Box)(({ theme }) => ({
//   display: 'inline-flex',
//   alignItems: 'center',
//   justifyContent: 'center',
//   width: 40,
//   height: 40,
//   borderRadius: '10px',
//   marginRight: '12px',
//   backgroundColor: theme.palette.primary.light,
//   color: theme.palette.primary.contrastText,
// }));

// export const MyAccountPage = () => {
//   const theme = useTheme();
//   const mode = theme.palette.mode;
//   const [user, setUser] = useState(null);

//   useEffect(() => {
//     if (JSON.parse(localStorage.getItem('user')) !== null) {
//       setUser(JSON.parse(localStorage.getItem('user')));
//     }
//   }, []);

//   const getCleanImageUrl = (url) => {
//     if (!url) return null;
//     const parts = url.split('/UsersImages/');
//     return parts.length > 2 ? `${parts[0]}/UsersImages/${parts[2]}` : url;
//   };

//   const profileImage = user?.data?.profileImg ? getCleanImageUrl(user.data.profileImg) : null;

//   const getInitials = (name) => {
//     if (!name) return 'U';
//     return name
//       .split(' ')
//       .map((word) => word[0])
//       .join('')
//       .toUpperCase()
//       .slice(0, 2);
//   };

//   if (!user) {
//     return (
//       <Container
//         style={{
//           minHeight: '100vh',
//           display: 'flex',
//           alignItems: 'center',
//           justifyContent: 'center',
//         }}
//       >
//         <Typography>Loading...</Typography>
//       </Container>
//     );
//   }

//   return (
//     <Container
//       style={{
//         padding: '2rem 1rem',
//         backgroundColor: 'transparent',
//         minHeight: '100vh',
//       }}
//     >
//       <Box sx={{ maxWidth: '900px', margin: '0 auto' }}>
//         {/* Header */}
//         <Box sx={{ mb: 4, textAlign: 'center', marginTop: '60px' }}>
//           <Typography
//             variant="h4"
//             sx={{
//               fontWeight: 700,
//               mb: 1,
//               color: mode === 'dark' ? '#fff' : '#333',
//             }}
//           >
//             My Account
//           </Typography>
//           <Typography
//             variant="body1"
//             sx={{
//               color: mode === 'dark' ? '#b0b0b0' : '#666',
//             }}
//           >
//             Manage your personal information and account details
//           </Typography>
//         </Box>

//         <ProfileCard style={{ background: '#fff' }}>
//           <CardContent sx={{ p: 4 }}>
//             {/* Profile Section */}
//             <Grid container spacing={3} sx={{ mb: 4, backgroundColor: '#fff' }}>
//               <Grid item xs={12} md={4} sx={{ display: 'flex', justifyContent: 'center' }}>
//                 <AvatarContainer>
//                   <StyledAvatar alt={user?.data?.name || 'User'} src={profileImage}>
//                     {!profileImage && (
//                       <Typography sx={{ fontSize: '2rem', fontWeight: 700 }}>
//                         {getInitials(user?.data?.name)}
//                       </Typography>
//                     )}
//                   </StyledAvatar>
//                   <Chip
//                     icon={<CheckCircleIcon />}
//                     label={user?.data?.active ? 'Active' : 'Inactive'}
//                     color={user?.data?.active ? 'success' : 'default'}
//                     size="small"
//                     sx={{
//                       position: 'absolute',
//                       bottom: 5,
//                       right: 5,
//                       fontWeight: 600,
//                     }}
//                   />
//                 </AvatarContainer>
//               </Grid>

//               <Grid item xs={12} md={8}>
//                 <Box sx={{ textAlign: { xs: 'center', md: 'left' } }}>
//                   <Typography
//                     variant="h5"
//                     sx={{
//                       fontWeight: 700,
//                       mb: 1,
//                       color: mode === 'dark' ? '#fff' : '#333',
//                       display: 'flex',
//                       alignItems: 'center',
//                       gap: 1,
//                     }}
//                   >
//                     <PersonIcon sx={{ color: theme.palette.primary.main }} />
//                     {user?.data?.name || 'User'}
//                   </Typography>

//                   <Chip
//                     icon={<PushPinIcon />}
//                     label={user?.data?.role || 'No role assigned'}
//                     variant="outlined"
//                     sx={{
//                       mb: 2,
//                       fontWeight: 500,
//                       borderColor: theme.palette.primary.main,
//                       color: theme.palette.primary.main,
//                     }}
//                   />

//                   <Typography
//                     variant="body2"
//                     sx={{
//                       color: mode === 'dark' ? '#b0b0b0' : '#666',
//                       display: 'flex',
//                       alignItems: 'center',
//                       gap: 1,
//                       justifyContent: { xs: 'center', md: 'flex-start' },
//                     }}
//                   >
//                     <CircleIcon
//                       sx={{ fontSize: 8, color: user?.data?.active ? '#4caf50' : '#f44336' }}
//                     />
//                     Member since {moment(user?.data?.createdAt).format('MMMM YYYY')}
//                   </Typography>
//                 </Box>
//               </Grid>
//             </Grid>

//             {/* Information Cards */}
//             <Grid container spacing={3}>
//               {/* Contact Information */}
//               <Grid item xs={12} md={6}>
//                 <InfoCard>
//                   <Typography
//                     variant="h6"
//                     sx={{
//                       mb: 3,
//                       fontWeight: 600,
//                       color: mode === 'dark' ? '#fff' : '#333',
//                       display: 'flex',
//                       alignItems: 'center',
//                     }}
//                   >
//                     <IconContainer>
//                       <PhoneAndroidIcon />
//                     </IconContainer>
//                     Contact Information
//                   </Typography>

//                   <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5 }}>
//                     <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                       <IconContainer>
//                         <PhoneAndroidIcon />
//                       </IconContainer>
//                       <Box>
//                         <Typography
//                           variant="caption"
//                           sx={{ color: mode === 'dark' ? '#b0b0b0' : '#666' }}
//                         >
//                           Phone Number
//                         </Typography>
//                         <Typography
//                           sx={{ fontWeight: 500, color: mode === 'dark' ? '#fff' : '#333' }}
//                         >
//                           {user?.data?.phone || 'Not provided'}
//                         </Typography>
//                       </Box>
//                     </Box>

//                     <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                       <IconContainer>
//                         <AlternateEmailIcon />
//                       </IconContainer>
//                       <Box>
//                         <Typography
//                           variant="caption"
//                           sx={{ color: mode === 'dark' ? '#b0b0b0' : '#666' }}
//                         >
//                           Email Address
//                         </Typography>
//                         <Typography
//                           sx={{ fontWeight: 500, color: mode === 'dark' ? '#fff' : '#333' }}
//                         >
//                           {user?.data?.email || 'Not provided'}
//                         </Typography>
//                       </Box>
//                     </Box>
//                   </Box>
//                 </InfoCard>
//               </Grid>

//               {/* General Information */}
//               <Grid item xs={12} md={6}>
//                 <InfoCard>
//                   <Typography
//                     variant="h6"
//                     sx={{
//                       mb: 3,
//                       fontWeight: 600,
//                       color: mode === 'dark' ? '#fff' : '#333',
//                       display: 'flex',
//                       alignItems: 'center',
//                     }}
//                   >
//                     <IconContainer>
//                       <CalendarMonthIcon />
//                     </IconContainer>
//                     General Information
//                   </Typography>

//                   <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5 }}>
//                     <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                       <IconContainer>
//                         <AutorenewIcon />
//                       </IconContainer>
//                       <Box>
//                         <Typography
//                           variant="caption"
//                           sx={{ color: mode === 'dark' ? '#b0b0b0' : '#666' }}
//                         >
//                           Account Status
//                         </Typography>
//                         <Typography
//                           sx={{ fontWeight: 500, color: mode === 'dark' ? '#fff' : '#333' }}
//                         >
//                           {user?.data?.active ? 'Active' : 'Inactive'}
//                           <Chip
//                             size="small"
//                             label={user?.data?.active ? 'Active' : 'Inactive'}
//                             color={user?.data?.active ? 'success' : 'error'}
//                             sx={{ ml: 1, height: 20, fontSize: '0.7rem' }}
//                           />
//                         </Typography>
//                       </Box>
//                     </Box>

//                     <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                       <IconContainer>
//                         <CalendarMonthIcon />
//                       </IconContainer>
//                       <Box>
//                         <Typography
//                           variant="caption"
//                           sx={{ color: mode === 'dark' ? '#b0b0b0' : '#666' }}
//                         >
//                           Created Date
//                         </Typography>
//                         <Typography
//                           sx={{ fontWeight: 500, color: mode === 'dark' ? '#fff' : '#333' }}
//                         >
//                           {user?.data?.createdAt
//                             ? moment(user.data.createdAt).format('DD MMMM YYYY - h:mm A')
//                             : 'Not available'}
//                         </Typography>
//                       </Box>
//                     </Box>

//                     <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                       <IconContainer>
//                         <CalendarMonthIcon />
//                       </IconContainer>
//                       <Box>
//                         <Typography
//                           variant="caption"
//                           sx={{ color: mode === 'dark' ? '#b0b0b0' : '#666' }}
//                         >
//                           Last Updated
//                         </Typography>
//                         <Typography
//                           sx={{ fontWeight: 500, color: mode === 'dark' ? '#fff' : '#333' }}
//                         >
//                           {user?.data?.updatedAt
//                             ? moment(user.data.updatedAt).format('DD MMMM YYYY - h:mm A')
//                             : 'Not available'}
//                         </Typography>
//                       </Box>
//                     </Box>
//                   </Box>
//                 </InfoCard>
//               </Grid>
//             </Grid>

//             {/* Stats Footer */}
//             <Box
//               sx={{
//                 mt: 4,
//                 pt: 3,
//                 borderTop: `1px solid ${mode === 'dark' ? '#444' : '#e0e0e0'}`,
//                 display: 'flex',
//                 justifyContent: 'space-around',
//                 flexWrap: 'wrap',
//                 gap: 3,
//               }}
//             >
//               <Box sx={{ textAlign: 'center' }}>
//                 <Typography
//                   variant="h6"
//                   sx={{
//                     fontWeight: 700,
//                     color: theme.palette.primary.main,
//                     mb: 0.5,
//                   }}
//                 >
//                   {moment(user?.data?.createdAt).fromNow(true)}
//                 </Typography>
//                 <Typography variant="body2" sx={{ color: mode === 'dark' ? '#b0b0b0' : '#666' }}>
//                   Time as member
//                 </Typography>
//               </Box>

//               <Box sx={{ textAlign: 'center' }}>
//                 <Typography
//                   variant="h6"
//                   sx={{
//                     fontWeight: 700,
//                     color: user?.data?.active ? '#4caf50' : '#f44336',
//                     mb: 0.5,
//                   }}
//                 >
//                   {user?.data?.active ? 'Active' : 'Inactive'}
//                 </Typography>
//                 <Typography variant="body2" sx={{ color: mode === 'dark' ? '#b0b0b0' : '#666' }}>
//                   Current Status
//                 </Typography>
//               </Box>

//               <Box sx={{ textAlign: 'center' }}>
//                 <Typography
//                   variant="h6"
//                   sx={{
//                     fontWeight: 700,
//                     color: mode === 'dark' ? '#fff' : '#333',
//                     mb: 0.5,
//                   }}
//                 >
//                   {user?.data?.role || 'User'}
//                 </Typography>
//                 <Typography variant="body2" sx={{ color: mode === 'dark' ? '#b0b0b0' : '#666' }}>
//                   User Role
//                 </Typography>
//               </Box>
//             </Box>
//           </CardContent>
//         </ProfileCard>

//         {/* Last Updated Note */}
//         <Typography
//           variant="body2"
//           sx={{
//             textAlign: 'center',
//             mt: 3,
//             color: mode === 'dark' ? '#888' : '#999',
//             fontStyle: 'italic',
//           }}
//         >
//           Information last updated on {moment().format('MMMM DD, YYYY')}
//         </Typography>
//       </Box>
//     </Container>
//   );
// };

















// 20-5-2026

import React, { useEffect, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import Avatar from '@mui/material/Avatar';
import moment from 'moment-timezone';
import PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid';
import AlternateEmailIcon from '@mui/icons-material/AlternateEmail';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import PersonIcon from '@mui/icons-material/Person';
import PushPinIcon from '@mui/icons-material/PushPin';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import CircleIcon from '@mui/icons-material/Circle';
import { useSidebarWidth } from '../Utility/useSidebarWidth'; // ← نفس import الـ ChannelTable

const C = {
  bg:        '#F7F8FC',
  white:     '#FFFFFF',
  border:    '#E8EAF0',
  accent:    '#0D47A1',
  text:      '#1C2340',
  textMuted: '#7B829A',
  success:   '#12B76A',
  warning:   '#F79009',
  shadow:    '0 1px 3px rgba(16,24,40,0.08)',
  shadowMd:  '0 4px 16px rgba(16,24,40,0.10)',
  iconBg:    '#EEF2FF',
};

const InfoRow = ({ icon: Icon, label, value, extra }) => (
  <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
    <div style={{
      width: 36, height: 36, borderRadius: 9, background: C.iconBg,
      display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
    }}>
      <Icon sx={{ fontSize: 18, color: C.accent }} />
    </div>
    <div>
      <div style={{ fontSize: 10, fontWeight: 600, color: C.textMuted, letterSpacing: '0.07em', textTransform: 'uppercase', fontFamily: "'DM Sans', sans-serif", marginBottom: 2 }}>
        {label}
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        <span style={{ fontSize: 14, fontWeight: 600, color: C.text, fontFamily: "'DM Sans', sans-serif" }}>{value}</span>
        {extra}
      </div>
    </div>
  </div>
);

const SectionCard = ({ title, icon: Icon, children }) => (
  <div style={{
    background: C.white, border: `1px solid ${C.border}`,
    borderRadius: 14, padding: '20px 22px',
    boxShadow: C.shadow, flex: 1,
  }}>
    <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 20 }}>
      <div style={{ width: 36, height: 36, borderRadius: 9, background: C.iconBg, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Icon sx={{ fontSize: 18, color: C.accent }} />
      </div>
      <span style={{ fontSize: 15, fontWeight: 700, color: C.text, fontFamily: "'DM Sans', sans-serif" }}>{title}</span>
    </div>
    <div style={{ display: 'flex', flexDirection: 'column', gap: 18 }}>
      {children}
    </div>
  </div>
);

const StatItem = ({ value, label, color }) => (
  <div style={{ textAlign: 'center' }}>
    <div style={{ fontSize: 22, fontWeight: 800, color: color || C.accent, fontFamily: "'DM Sans', sans-serif", marginBottom: 4 }}>{value}</div>
    <div style={{ fontSize: 12, color: C.textMuted, fontFamily: "'DM Sans', sans-serif" }}>{label}</div>
  </div>
);

export const MyAccountPage = () => {
  const theme      = useTheme();
  const mode       = theme.palette.mode;
  const sidebarW   = useSidebarWidth(); // ← نفس الـ ChannelTable
  const [user, setUser] = useState(null);

  useEffect(() => {
    const u = localStorage.getItem('user');
    if (u) setUser(JSON.parse(u));
  }, []);

  const getCleanImageUrl = (url) => {
    if (!url) return null;
    const parts = url.split('/UsersImages/');
    return parts.length > 2 ? `${parts[0]}/UsersImages/${parts[2]}` : url;
  };

  const profileImage = user?.data?.profileImg ? getCleanImageUrl(user.data.profileImg) : null;

  const getInitials = (name) => {
    if (!name) return 'U';
    return name.split(' ').map(w => w[0]).join('').toUpperCase().slice(0, 2);
  };

  if (!user) return (
    <div style={{
      position: 'fixed', top: 50, left: sidebarW, right: 0, bottom: 0,
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: C.bg, transition: 'left 0.25s cubic-bezier(0.4,0,0.2,1)',
    }}>
      <div style={{ fontSize: 14, color: C.textMuted, fontFamily: "'DM Sans', sans-serif" }}>Loading...</div>
    </div>
  );

  const isActive = user?.data?.active;

  return (
    // ← نفس بالظبط pattern الـ ChannelTable
    <div style={{
      position: 'fixed',
      top: 50,
      left: sidebarW,
      right: 0,
      bottom: 0,
      transition: 'left 0.25s cubic-bezier(0.4,0,0.2,1)',
      overflowY: 'auto',
      background: C.bg,
      fontFamily: "'DM Sans', sans-serif",
    }}>
      <div style={{ padding: '32px 28px 48px', maxWidth: 900 }}>

        {/* ── Page title ── */}
        <div style={{ marginBottom: 28 }}>
          <div style={{ fontSize: 26, fontWeight: 800, color: C.text, letterSpacing: '-0.02em' }}>My Account</div>
          <div style={{ fontSize: 13, color: C.textMuted, marginTop: 4 }}>Manage your personal information and account details</div>
        </div>

        {/* ── Main card ── */}
        <div style={{
          background: C.white, border: `1px solid ${C.border}`,
          borderRadius: 16, boxShadow: C.shadowMd,
          padding: '28px 28px 0', overflow: 'hidden',
        }}>

          {/* Profile header */}
          <div style={{ display: 'flex', alignItems: 'flex-start', gap: 22, marginBottom: 28, flexWrap: 'wrap' }}>
            {/* Avatar */}
            <div style={{ position: 'relative', flexShrink: 0 }}>
              <Avatar
                alt={user?.data?.name || 'User'}
                src={profileImage}
                sx={{
                  width: 90, height: 90,
                  borderRadius: '16px',
                  bgcolor: C.accent,
                  border: `3px solid ${C.white}`,
                  boxShadow: C.shadowMd,
                }}
              >
                {!profileImage && (
                  <span style={{ fontSize: '2rem', fontWeight: 800, color: '#fff', fontFamily: "'DM Sans', sans-serif" }}>
                    {getInitials(user?.data?.name)}
                  </span>
                )}
              </Avatar>
              <div style={{
                position: 'absolute', bottom: -6, left: '50%', transform: 'translateX(-50%)',
                background: isActive ? C.success : '#9e9e9e',
                color: '#fff', fontSize: 10, fontWeight: 700,
                padding: '2px 10px', borderRadius: 20,
                border: `2px solid ${C.white}`,
                letterSpacing: '0.05em', whiteSpace: 'nowrap',
                fontFamily: "'DM Sans', sans-serif",
              }}>
                {isActive ? '● ACTIVE' : '● INACTIVE'}
              </div>
            </div>

            {/* Name + role */}
            <div style={{ paddingTop: 4 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap', marginBottom: 8 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                  <PersonIcon sx={{ fontSize: 16, color: C.textMuted }} />
                  <span style={{ fontSize: 20, fontWeight: 800, color: C.text }}>{user?.data?.name || 'User'}</span>
                </div>
                <div style={{
                  display: 'inline-flex', alignItems: 'center', gap: 5,
                  padding: '3px 12px', borderRadius: 20,
                  border: `1px solid ${C.warning}40`,
                  background: `${C.warning}12`,
                  fontSize: 12, fontWeight: 600, color: C.warning,
                }}>
                  <PushPinIcon sx={{ fontSize: 12 }} />
                  {user?.data?.role || 'No Role'}
                </div>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 12, color: C.textMuted }}>
                <CircleIcon sx={{ fontSize: 8, color: isActive ? C.success : '#9e9e9e' }} />
                Member since {moment(user?.data?.createdAt).format('MMMM YYYY')}
              </div>
            </div>
          </div>

          {/* Info cards */}
          <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap', marginBottom: 28 }}>
            <SectionCard title="Contact Information" icon={PhoneAndroidIcon}>
              <InfoRow icon={PhoneAndroidIcon} label="Phone Number" value={user?.data?.phone || 'Not provided'} />
              <InfoRow icon={AlternateEmailIcon} label="Email Address" value={user?.data?.email || 'Not provided'} />
            </SectionCard>

            <SectionCard title="General Information" icon={CalendarMonthIcon}>
              <InfoRow
                icon={AutorenewIcon}
                label="Account Status"
                value={isActive ? 'Active' : 'Inactive'}
                extra={
                  <span style={{
                    fontSize: 10, fontWeight: 700, padding: '2px 8px', borderRadius: 20,
                    background: isActive ? `${C.success}18` : '#f4433618',
                    color: isActive ? C.success : '#f44336',
                    border: `1px solid ${isActive ? C.success : '#f44336'}30`,
                  }}>
                    {isActive ? 'ACTIVE' : 'INACTIVE'}
                  </span>
                }
              />
              <InfoRow icon={CalendarMonthIcon} label="Created Date"
                value={user?.data?.createdAt ? moment(user.data.createdAt).format('DD MMMM YYYY - h:mm A') : 'Not available'}
              />
              <InfoRow icon={AutorenewIcon} label="Last Updated"
                value={user?.data?.updatedAt ? moment(user.data.updatedAt).format('DD MMMM YYYY - h:mm A') : 'Not available'}
              />
            </SectionCard>
          </div>

          {/* Stats footer */}
          <div style={{
            borderTop: `1px solid ${C.border}`,
            padding: '20px 4px 24px',
            display: 'flex', justifyContent: 'space-around', flexWrap: 'wrap', gap: 16,
          }}>
            <StatItem value={moment(user?.data?.createdAt).fromNow(true)} label="Time as member" color={C.accent} />
            <StatItem value={isActive ? 'Active' : 'Inactive'} label="Current Status" color={isActive ? C.success : '#9e9e9e'} />
            <StatItem value={user?.data?.role || 'User'} label="User Role" color={C.text} />
          </div>
        </div>

        <div style={{ textAlign: 'center', marginTop: 16, fontSize: 12, color: '#bbb', fontStyle: 'italic' }}>
          Information last updated on {moment().format('MMMM DD, YYYY')}
        </div>

      </div>
    </div>
  );
};
